import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { VueReCaptcha } from 'vue-recaptcha-v3'

Vue.config.productionTip = false

Vue.use(VueReCaptcha, {
  siteKey: '6Le1js8ZAAAAAII2odTVXhwidc4fN-DAcdb91EXU'
  // loaderOptions: {
  //   explicitRenderParameters: {
  //     badge: 'inline'
  //   }
  // }
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
